import { Card } from '@whistler-ui/k2/components/Card';
import { Skeleton } from '@whistler-ui/k2/components/Skeleton';
import { Stack } from '@whistler-ui/k2/components/Stack';

import { ImplementationStepsSkeleton } from './ImplementationStepsSkeleton';

export const BasePagesSkeleton = () => {
  return (
    <Stack
      direction="column"
      gap={6}
      className="flex-1"
      data-testid="base-pages-skeleton"
    >
      <Stack direction="row" gap={3}>
        <Skeleton width={140} height={36} />
        <Skeleton width={140} height={36} />
      </Stack>
      <Stack direction="row" gap={6} className="flex-1">
        <Card
          classNames={{
            container: 'flex-1',
            content: 'flex flex-col gap-10',
          }}
        >
          <Skeleton width="100%" height={48} />
          <ImplementationStepsSkeleton />
        </Card>
        <Skeleton width={320} height="100%" />
      </Stack>
    </Stack>
  );
};
